import(/* webpackMode: "eager", webpackExports: ["EquipmentDetail"] */ "/vercel/path0/components/equipment/detail/EquipmentDetail.tsx");
